import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Button from "../shared/Button";
import Input from "../shared/Input";
import Card from "../shared/Card";
import { resetPassword } from "../../api/auth";
import Swal from "sweetalert2";
import logo from "../../assets/chatea.png";

const ResetPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [errors, setErrors] = useState({});

  // Extraer token de la URL
  const urlParams = new URLSearchParams(location.search);
  const token = urlParams.get("token");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.newPassword) {
      newErrors.newPassword = "La nueva contraseña es requerida";
    } else if (formData.newPassword.length < 6) {
      newErrors.newPassword = "La contraseña debe tener al menos 6 caracteres";
    }

    if (!formData.confirmPassword) {
      newErrors.confirmPassword = "Debes confirmar la contraseña";
    } else if (formData.confirmPassword !== formData.newPassword) {
      newErrors.confirmPassword = "Las contraseñas no coinciden";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    if (!token) {
      Swal.fire({
        icon: "error",
        title: "Enlace inválido",
        text: "El enlace de recuperación es inválido o ha expirado",
      });
      navigate("/recovery");
      return;
    }

    setLoading(true);
    try {
      await resetPassword({
        token: token,
        password: formData.newPassword,
      });

      Swal.fire({
        icon: "success",
        title: "Contraseña actualizada",
        text: "Tu contraseña ha sido actualizada correctamente",
      });

      navigate("/login");
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "Error al actualizar la contraseña",
      });
    } finally {
      setLoading(false);
    }
  };

  const navigateToLogin = () => {
    navigate("/login");
  };

  if (!token) {
    return (
      <Card logo={logo} title="Enlace inválido" className="login-form">
        <div className="login-form__form">
          <p className="text-center">
            El enlace de recuperación de contraseña es inválido o ha expirado.
          </p>
          <Button
            variant="primary"
            onClick={() => navigate("/recovery")}
            fullWidth
          >
            Solicitar nuevo enlace
          </Button>
        </div>
      </Card>
    );
  }

  return (
    <Card
      logo={logo}
      title="Establecer nueva contraseña"
      className="login-form"
    >
      <form onSubmit={handleSubmit} className="login-form__form">
        <p className="reset-form__instructions">
          Confirma tu nueva contraseña.
        </p>
        <Input
          type="password"
          label="Nueva Contraseña"
          name="newPassword"
          value={formData.newPassword}
          onChange={handleChange}
          error={errors.newPassword}
        />
        <Input
          type="password"
          label="Confirmar Nueva Contraseña"
          name="confirmPassword"
          value={formData.confirmPassword}
          onChange={handleChange}
          error={errors.confirmPassword}
        />
        <Button type="submit" variant="primary" disabled={loading} fullWidth>
          {loading ? "Actualizando..." : "Actualizar contraseña"}
        </Button>
        <p className="login-form__register" onClick={navigateToLogin}>
          Volver a iniciar sesión
        </p>
      </form>
    </Card>
  );
};

export default ResetPassword;
